import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { UserMfaDevice } from '@lib/api/entities';
import { SnFormFieldConfig } from '@lib/form';
import { t, TranslationService } from '@lib/translation';

@Component({
  templateUrl: './mfa-verification-dialog.component.html',
  styleUrls: ['./mfa-verification-dialog.component.scss'],
})
export class MfaVerificationDialogComponent implements OnInit, OnDestroy {
  public verificationForm = new UntypedFormGroup({});
  public formModel: any = {};
  public isLoading = false;
  public errorMessage: string;

  public formFields: SnFormFieldConfig[] = [];

  private readonly _destroy$ = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mfa: UserMfaDevice;
      errorMessage?: string;
    },
    private readonly _dialogRef: MatDialogRef<MfaVerificationDialogComponent>,
    private readonly _translationService: TranslationService,
  ) {
    this.errorMessage = data?.errorMessage;
  }

  public ngOnInit(): void {
    this._createFormFields();
  }

  private _createFormFields(): void {
    this.formFields = [
      {
        key: 'password',
        type: 'input',
        templateOptions: this._translationService.createTranslatedFieldOptions(
          'account.dialogs.changePassword.currentPassword.label',
          'account.dialogs.changePassword.currentPassword.placeholder',
          {
            type: 'password',
            required: true,
            toggleMask: true,
            attributes: {
              autocomplete: 'current-password',
            },
          }
        ),
      },
    ];
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public cancel(): void {
    this._dialogRef.close();
  }

  public confirm(): void {
    if (this.verificationForm.invalid) {
      return;
    }

    this.isLoading = true;

    this._dialogRef.close({
      confirmed: true,
      password: this.formModel.password,
    });
  }
}
